/**
 * @generated SignedSource<<6e12fec9f25c00b9ca2ed9f05b580096>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useDisplayInfo_multiskus$data = ReadonlyArray<{
  readonly displayInfo: {
    readonly ctas: {
      readonly showAcceptOffer: boolean | null;
      readonly showMakeOffer: boolean | null;
      readonly showPurchase: boolean | null;
      readonly showRequestPrice: boolean | null;
    } | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "useDisplayInfo_multiskus";
}>;
export type useDisplayInfo_multiskus$key = ReadonlyArray<{
  readonly " $data"?: useDisplayInfo_multiskus$data;
  readonly " $fragmentSpreads": FragmentRefs<"useDisplayInfo_multiskus">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "useDisplayInfo_multiskus",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        },
        {
          "kind": "Literal",
          "name": "page",
          "value": "pdp"
        }
      ],
      "concreteType": "SkuDisplayInfo",
      "kind": "LinkedField",
      "name": "displayInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CTADisplay",
          "kind": "LinkedField",
          "name": "ctas",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showPurchase",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showMakeOffer",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showRequestPrice",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showAcceptOffer",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};

(node as any).hash = "50bc1fa804a4d1d959ea091e55e9da29";

export default node;
